<script setup lang="ts">
import { inject, onMounted, onUnmounted, watch, computed, type ComputedRef } from 'vue'
import type { UiDetailTabMeta } from './UiDetailTabs.vue'

export interface UiDetailTabsItemProps {
  value: string
  label: string
  count?: number
  disabled?: boolean
}

const props = withDefaults(defineProps<UiDetailTabsItemProps>(), {
  disabled: false,
})

const registerItem = inject<(item: UiDetailTabMeta) => void>('UiDetailTabs:registerItem')
const unregisterItem = inject<(value: string) => void>('UiDetailTabs:unregisterItem')
const activeValue = inject<ComputedRef<string | undefined>>('UiDetailTabs:activeValue')

const isActive = computed(() => activeValue?.value === props.value)

function register() {
  registerItem?.({
    value: props.value,
    label: props.label,
    count: props.count,
    disabled: props.disabled,
  })
}

onMounted(() => register())

watch(() => [props.label, props.count, props.disabled], () => register(), { deep: true })

onUnmounted(() => unregisterItem?.(props.value))
</script>

<template>
  <div v-if="isActive" class="block">
    <slot />
  </div>
</template>
